export default {
  transport: {
    name: 'Transport',
    displayName: 'Transport',
    iconUrl: require('@/assets/icons/transport.svg'),
    lineIconUrl: require('@/assets/icons/transport_line.svg'),
    listIcon: require('@/assets/icons/transport_line.svg'),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  education: {
    name: 'Schools & Universities',
    displayName: 'Education',
    iconUrl: require('@/assets/icons/education.svg'),
    lineIconUrl: require('@/assets/icons/education_line.svg'),
    listIcon: require('@/assets/icons/education_line.svg'),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  health: {
    name: 'Hospitals',
    displayName: 'Hospitals',
    iconUrl: require('@/assets/icons/health.svg'),
    lineIconUrl: require('@/assets/icons/health_line.svg'),
    listIcon: require('@/assets/icons/health_line.svg'),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  outdoor: {
    name: 'Parks, Playgrounds, Recreational',
    displayName: 'Amenities',
    iconUrl: require('@/assets/icons/recreation.svg'),
    lineIconUrl: require('@/assets/icons/recreation_line.svg'),
    listIcon: require('@/assets/icons/recreation_line.svg'),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  childcare: {
    name: 'Childcare & Early Learning',
    displayName: 'Childcare & Early Learning',
    iconUrl: require('@/assets/icons/childcare.svg'),
    lineIconUrl: require('@/assets/icons/childcare_line.svg'),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  shopping: {
    name: 'Retail',
    displayName: 'Shopping',
    iconUrl: require('@/assets/icons/shop.svg'),
    lineIconUrl: require('@/assets/icons/shop_line.svg'),
    listIcon: require('@/assets/icons/shop_line.svg'),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  food: {
    name: 'Food & Drink',
    displayName: 'Food & Drink',
    iconUrl: require('@/assets/icons/food.svg'),
    lineIconUrl: require('@/assets/icons/food_line.svg'),
    listIcon: require('@/assets/cat_icons/cat_food.svg'),
    venue: [],
    groupedMarkers: [],
    markers: []
  },
  professional: {
    name: 'Career Hubs',
    displayName: 'Career Hubs',
    iconUrl: require('@/assets/icons/food.svg'),
    lineIconUrl: require('@/assets/icons/food_line.svg'),
    listIcon: require('@/assets/cat_icons/cat_professional.svg'),
    venue: [],
    groupedMarkers: [],
    markers: []
  }
};



// WEBPACK FOOTER //
// ./src/model/Poi.js